
class customTabs extends HTMLElement {
  constructor() {
    super();

    this.tabContent = document.querySelectorAll('[tabs-js] .tabcontent');
    this.tabLinks = document.querySelectorAll('[tabs-js] .tablinks');
    let temp_this = this;

    this.tabLinks.forEach(function(tab){
      tab.addEventListener('click', function(event){
        temp_this.toggleTab(event);
      })
    })
  }

 toggleTab(event) {
    this.tabContent.forEach(function(tab){
      tab.classList.add('hide_tab');
    });

    this.tabLinks.forEach(function(tabLink){
      tabLink.className = tabLink.className.replace(" active", "");
    })

    let activeContent = document.getElementById(event.currentTarget.getAttribute('data-id'));
    activeContent && activeContent.classList.remove('hide_tab');

    //re-iniaite flickity
    let flkty = Flickity(activeContent);
    if(flkty){
      flkty.resize();
    }

    //update collection url
    let collectionUrl = event.currentTarget.getAttribute('data-collection-url');
   // console.log(collectionUrl)
    //console.log(this.querySelector('.collection-button a'))
    if(collectionUrl){
      let collectionBtnElem = this.querySelector('.collection-button a');
      if(collectionBtnElem){
        collectionBtnElem.href = collectionUrl;
      }
    }

    event.currentTarget.classList.add("active");
  }

}
customElements.define('custom-tabs', customTabs);
